import { FC } from 'react'

import { Outlet } from '@tanstack/react-router'

import { Cluster, Typography } from '@forto-dev/phoenix-ui-core'
import { Layout } from '@forto-dev/phoenix-ui-core/ship'

import { Back } from '@/fragments/back'
import { Footer } from '@/fragments/footer'
import { Header } from '@/fragments/header'

import { useLocalisation } from '../../utils/localisation'

export const ReportCreateLayout: FC = () => {
  const { translate } = useLocalisation()
  return (
    <Layout
      header={<Header />}
      navigation={<Back to="/reports" />}
      title={
        <Cluster gap={8}>
          <Typography variant="h4">{translate('reports.create.title')}</Typography>
        </Cluster>
      }
      main={<Outlet />}
      footer={<Footer />}
    />
  )
}
